import React from 'react';

import { useAppSelector } from 'src/store/store';

import RestrictionsPageNewExperience from './restrictionPageNewExperience/restrictionsPageNewExperience';
import RestrictionsPageLegacy from './restrictionsPageLegacy/restrictionsPageLegacy';

/**
 * Main component.
 */
const RestrictionsPage = () => {
  const { featureFlags, isFeatureFlagsLoaded } = useAppSelector((state) => state.user);
  const isTaskGroupingEnabled = isFeatureFlagsLoaded && featureFlags.TASK_GROUPING;

  return isTaskGroupingEnabled ? <RestrictionsPageNewExperience /> : <RestrictionsPageLegacy />;
};

// **** Export **** //

export default RestrictionsPage;
